import React from "react";
import Caption from "component/caption/Caption";
import { Theme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import t from "module/translations";
import { EntityIdentifier } from "module/entity/types";
import AddAttachmentButton from "module/attachment/enrichedComponent/AddAttachmentButton";
import { getEntityIdentifierKey } from "module/entity/helper/getEntityIdentifierKey";
import MaintenanceTaskProcessStepAttachmentListItemContainer from "module/maintenanceTaskProcessStepAttachment/enrichedComponent/list/item/MaintenanceTaskProcessStepAttachmentListItemContainer";

const useStyles = makeStyles((theme: Theme) => ({
  list: {
    width: "100%",
    display: "flex",
    "& > *": {
      margin: theme.spacing(2),
    },
    justifyContent: "flex-start",
    flexWrap: "wrap",
  },
}));

interface Props {
  canAdd: boolean;
  add: (mime: string, data: string) => void;
  entityIdentifiers: EntityIdentifier[];
}

const MaintenanceTaskProcessStepAttachmentList: React.FC<Props> = ({
  canAdd,
  add,
  entityIdentifiers,
}) => {
  const classes = useStyles();

  return (
    <div>
      <Caption {...{ text: t.maintenanceTask.processStep.attachmentsText }} />
      <div className={classes.list}>
        {entityIdentifiers.map((entityIdentifier) => (
          <MaintenanceTaskProcessStepAttachmentListItemContainer
            {...{
              entityIdentifier,
              key: getEntityIdentifierKey(entityIdentifier),
            }}
          />
        ))}
        {canAdd && <AddAttachmentButton {...{ add }} />}
      </div>
    </div>
  );
};

export default React.memo(MaintenanceTaskProcessStepAttachmentList);
